import React from 'react';

// Simple page transition component that doesn't require framer-motion
// This is a simplified version that just renders children without animation
const PageTransition = ({ children }) => {
  return <>{children}</>;
};

export default PageTransition;
